import React from "react";

import { Grid } from "@mui/material";

import { ProductSectionsProps } from "../types";
import { ProductDetailsSection } from "./components/Details";
import ProductPhoto from "./components/ProductPhoto";
import { Container } from "./styles";

interface ProductDetailsTabProps extends ProductSectionsProps {}

export const ProductDetails = ({ ...baseSectionProps }: ProductDetailsTabProps) => {
  return (
    <Container data-cy="despatch-details-maintenance">
      <Grid container>
        <Grid item xs={12} md={9}>
          <ProductDetailsSection {...baseSectionProps} />
        </Grid>
        <Grid item xs={12} md={3}>
          <ProductPhoto view={baseSectionProps.viewOnly} />
        </Grid>
      </Grid>
    </Container>
  );
};
